export default __webpack_public_path__ + "static/service_section_bg_2-7a97834020790104c0cd30752325b395.png";